"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _styled = require("../custom-button/styled");
var _excluded = ["label", "component", "isLoading", "spinColor", "type", "$bsStyle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = {
  loader: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2px 0'
  }
};
var LoadingButton = function LoadingButton(_ref) {
  var label = _ref.label,
    Component = _ref.component,
    isLoading = _ref.isLoading,
    spinColor = _ref.spinColor,
    type = _ref.type,
    $bsStyle = _ref.$bsStyle,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    type: type,
    disabled: isLoading,
    style: $bsStyle
  }, props), isLoading ? /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    style: styles.loader,
    type: "TailSpin",
    color: spinColor,
    height: 24,
    width: 24
  }) : label);
};
LoadingButton.propTypes = {
  label: _propTypes.default.string.isRequired,
  component: _propTypes.default.shape({}),
  isLoading: _propTypes.default.bool,
  spinColor: _propTypes.default.string,
  $bsStyle: _propTypes.default.shape({}),
  type: _propTypes.default.string
};
LoadingButton.defaultProps = {
  spinColor: 'white',
  component: _styled.CustomButton,
  isLoading: false,
  $bsStyle: null,
  type: 'button'
};
var _default = LoadingButton;
exports.default = _default;